import { all, fork } from 'redux-saga/effects';
import { watchGetTmMetadata } from './app';
import {
  watchChangePassword,
  watchChangeRole,
  watchLogin,
  watchLogout,
  watchResetLogout,
  watchUserModules
} from './authentication';

import {
  watchTMAlertDetailsColumns,
  watchTMGetAlertListingColumns as tmWatchTMGetAlertListingColumns,
  watchTMGetAlertsListingSettings,
  watchGetGlobalSettingsPageInfo,
  watchTMGetPageItemOperations,
  watchTMPutAlertsListingSettings,
  watchPutGlobalSettingsWidgetGroup,
  watchPutGlobalSettingsWidgetInfo,
  watchPutGlobalSettingsWidgets,
  watchNSMatchingConfigListingSettings,
  watchAMLSCommonGlobalSettings,
  watchGetCategoriesRunInstance,
  watchGetLiveSetsRunInstance,
  watchPostSegmentSetsRunInstance
} from './settings';

import {
  watchGetRIByScenarioId,
  watchPutRIByScenarioId,
  watchGetRIListByScenarioId
} from './trm/riskIndicators';

import {
  watchTRMGetConfigurations,
  watchTRMPutConfigurations
} from './trm/systemConfiguration';

import {
  watchGetColumnData,
  watchGetInvestigationData,
  watchGetStatusCount
} from './tm/investigation';
import {
  watchCloseAlert,
  watchGetAlertDetail,
  watchGetClusterViewDescription,
  watchGetCountries,
  watchGetFeatureCategoryTypes,
  watchGetHistAlert,
  watchgetHistAlertHeader,
  watchGetLinkedCustomerAlert,
  watchGetRiskIndicators,
  watchGetRiskIndicatorsGraph,
  watchgetTransaction,
  watchGetTransactionProductMapping,
  watchGetTransactionTypes
} from './tm/investigationDetail';

import {
  watchCustomerView as nsCustomerView,
  watchFigureData as nsDashboardWatchFigureData,
  watchGetAlertsAndHits as nsDashboardWatchAlertsAndHits,
  watchGetHitsDistribution as nsDashboardWatchHitsDistribution,
  watchGetSegments as nsDashboardSegments,
  watchGetSegmentsAndParameters as nsDashboardSegmentsAndParameters
} from './ns/dashboard';

import {
  watchAlertStatusBreakdown as tmWatchAlertStatusBreakdown,
  watchCustomerClusterChart as tmWatchCustomerClusterChart,
  watchCustomerView as tmWatchCustomerView,
  watchGetAlertsAndHits as tmWatchGetAlertsAndHits,
  watchGetAlertsYield as tmWatchGetAlertsYield,
  watchGetFigureData as tmWatchGetFigureData,
  watchGetNoIssueL1 as tmWatchGetNoIssueL1,
  watchGetStr as tmWatchGetStr,
  watchSegmentList as tmWatchSegmentList
} from './tm/dashboard';

import { watchGetAnalystThroughputData as nsWatchGetAnalystThroughputData } from './ns/analystThroughput';

import { watchGetSupervisorDashboardData as nswatchGetSupervisorDashboardData } from './ns/supervisorDashboard';

import {
  watchGetInvestListData as nsWatchGetInvestListData,
  watchCustomerTypesSegmentAlerts,
  watchDownloadSelectedAlerts,
  watchSendToCMAlerts
} from './ns/investigation';

import {
  watchGetInvestDetailData as nsWatchGetInvestDetailData,
  watchGetInvestDetailHitsData as nsWatchGetInvestDetailHitsData,
  watchGetInvestDetailPastHitsData as nsWatchGetInvestDetailPastHitsData
} from './ns/investigationDetail';

import {
  watchsaveMatchingConfigToStore as nsWatchsaveMatchingConfigToStore,
  watchGetMatchingConfigParametersData as nswatchGetMatchingConfigParametersData,
  watchGetMatchingConfigListData as nsWatchGetMatchingConfigListData,
  watchPostCreateMatchingConfigData as nsWatchPostCreateMatchingConfigData,
  watchGetMatchingConfigByIdData as nsWatchGetMatchingConfigByIdData,
  watchPutUpdateMatchingConfigData as nsWatchPutUpdateMatchingConfigData,
  watchGetMatchingConfigData as nsWatchGetMatchingConfigData,
  watchGetMatchingConfigRiskIndicatorList as nsWatchGetMatchingConfigRiskIndicatorList,
  watchGetMatchingConfigRiskParametersData as nswatchGetMatchingConfigRiskParametersData
} from './ns/matchingConfig';
import {
  watchGetSegmentsList as nsWatchGetSegmentsList,
  watchProceedScreening as nsWatchProceedScreening,
  watchScanUploadedFile as nsWatchScanUploadedFile,
  watchODNSHistoryCsvFileDownload as nsWatchODNSHistoryCsvFileDownload,
  watchProceedBulkScreening as nsWatchProceedBulkScreening,
  watchGetScreeningProgress as nsWatchGetScreeningProgress,
  watchGetMatchingConfigs as nsWatchGetMatchingConfigsBySegment,
  watchCancelHistoryDownload as nsWatchCancelHistoryDownload,
  watchStopBulkScreening as nsWatchStopBulkScreening
} from './ns/onDemandScreening';
import { watchGetNSCommomModuleData as nswatchGetNSCommomModuleData } from './ns/common';

import {
  watchGetRunInstanceResultListData as nsWatchGetRunInstanceResultListData,
  watchGetRunInstanceSummaryData as nsWatchGetRunInstanceSummaryData,
  watchGetAlertDetailData as nsWatchGetAlertDetailData,
  watchPostHitsUserFeedback as nsWatchPostHitsUserFeedback,
  watchGetRIWatchList as nswatchGetRIWatchList,
  watchGetRIWatchListCoverageReports as nswatchGetRIWatchListCoverageReports,
  watchGetRIWhiteList as nswatchGetRIWhiteList,
  watchPostDeployToProduction as nsWatchPostDeployToProduction,
  watchRunInstance as nswatchRunInstance,
  watchRunRunInstance as nsWatchRunRunInstance,
  watchRunInstanceViewExecution as nsWatchRunInstanceViewExecution,
  watchGetCutsomerType as nsWatchGetCutsomerType,
  watchPostCustomerType as nsWatchPostCustomerType,
  watchPutCustomerType as nsWatchPutCustomerType,
  watchDeleteCustomerType as nsWatchDeleteCustomerType
} from './ns/runInstance';

import {
  watchPostCreateTicketForChampion as nsWatchPostCreateTicketForChampion,
  watchGetCurrentChampion as nsWatchGetCurrentChampion,
  watchGetChampionChallengerDetails as nsWatchGetChampionChallengerDetails
} from './ns/tickets';

import {
  watchCrsDashboardGetFeatureCodesData as crsWatchCrsDashboardGetFeatureCodesData,
  watchCrsGetInitialDashboardData as crsWatchCrsGetInitialDashboardData,
  watchCrsResetDashboardData as crsWatchCrsResetDashboardData,
  watchGetClusterChartData as crsWatchGetClusterChartData,
  watchGetClusterCustomerListData as crsWatchGetClusterCustomerListData,
  watchGetClusterFeaturesData as crsWatchGetClusterFeaturesData,
  watchGetModelListData as crsWatchGetModelListData,
  watchGetSegmentListData as crsDashboardWatchGetSegmentListData
} from './crs/crsDashboard';

import {
  watchGetClusterListData as crsWatchGetClusterListData,
  watchGetCustomerListData as crsWatchGetCustomerListData,
  watchGetSegmentListData as crsWatchGetSegmentListData,
  watchGetCustomerTypeListData as crsWatchGetCustomerTypeListData,
  watchGetRiskLevelChangeListData as crsWatchGetRiskLevelChangeListData
} from './crs/crsListView';

import {
  watchGetRiskIndicators as crsWatchGetRiskIndicators,
  watchGetRiskIndicatorThresholds as crsWatchGetRiskIndicatorThresholds,
  watchPutRiskIndicatorThreshold as crsWatchPutRiskIndicatorThreshold,
  watchDeleteRiskIndicatorThreshold as crsWatchDeleteRiskIndicatorThreshold,
  watchUpdateRiskIndicatorThreshold as crsWatchUpdateRiskIndicatorThreshold,
  watchGetRiskIndicatorStaticProperties as crsWatchGetRiskIndicatorStaticProperties,
  watchPostRiskIndicatorTrigger as crsWatchPostRiskIndicatorTrigger
} from './crs/crsRiskIndicator';

import {
  watchClusterInformationView as crsWatchClusterInformationView,
  watchCRSClusterViewDescriptionCodesAPIView as crsWatchCRSClusterViewDescriptionCodesAPIView,
  watchCRSCustomerAlertHistoryView as crsWatchCRSCustomerAlertHistoryView,
  watchCRSFeatureCategoryCodesView as crsWatchCRSFeatureCategoryCodesView,
  watchCRSFeaturesCodesView as crsWatchCRSFeaturesCodesView,
  watchCRSModelExplainAbilityView as crsWatchCRSModelExplainabilityView,
  watchCRSModelExplainAbilityStatsView as crsWatchCRSModelExplainabilityStatsView,
  watchCRSRiskIndicatorsGraphView as crsWatchCRSRiskIndicatorsGraphView,
  watchCRSRiskIndicatorsView as crsWatchCRSRiskIndicatorsView,
  watchCRSTransactionHistoryView as crsWatchCRSTransactionHistoryView,
  watchCRSTransactionProductMappingView as crsWatchCRSTransactionProductMappingView,
  watchCRSTransactionTypesView as crsWatchCRSTransactionTypesView,
  watchCustomerProfileView as crsWatchCustomerProfileView,
  watchAssociatedCustomersView as crsWatchAssociatedCustomersView,
  watchTrendAnalysisDataView as crsWatchTrendAnalysisDataView,
  watchUpdateRiskScoreHistoryView as crsWatchUpdateRiskScoreHistoryView,
  watchAcceptRiskScoreView as crsWatchAcceptRiskScoreView,
  watchGetRiskScoreHistoryView as crsWatchGetRiskScoreHistoryView
} from './crs/crsRiskDetail';
import {
  watchAddTypologyToScenariosAPIDataWorker,
  watchApproveRejectTicketsDataWorker,
  watchCloneScenarioDataWorker,
  watchCreateChallengerDataWorker,
  watchCreateScenariosAPIData,
  watchDeleteScenariosAPIDataWorker,
  watchFetchCurrentChallengerWorker,
  watchFetchCurrentChampionDataWorker,
  watchFetchCurrentChampionResetDataWorker,
  watchFetchTicketsDataWorker,
  watchGetAllScenariosAPIData,
  watchGetBlackListData,
  watchGetChallengersSummaryAPIData,
  watchGetChallengersSummaryReset,
  watchGetScenarioDetailAPIData,
  watchGetScenarioDetailReset,
  watchGetTypologyListData,
  watchGetTypologyListOfScenariosData,
  watchPromoteChallengerAPIData,
  watchPutTypologyOfScenariosListDataWorker,
  watchRemoveTypologyFromScenarioDataWorker,
  watchRevertCurrentChampionAPIData,
  watchRunInstanceHistoryDataWorker,
  watchTriggerScenariosAPIDataWorker,
  watchUpdateScenariosAPIDataWorker,
  watchUploadConfirmData,
  watchUploadDiscardTypologiesData,
  watchSaveTypologySegments,
  watchFetchScenarioTypologies
} from './trm/trmDashboard';

import { watchFecthCaseDetailsByCaseId } from './cm/caseDetails';
import {
  watchChangeAlertAssignToUser,
  watchChangeAlertStatus,
  watchFecthAlertDetailsByAlertId,
  watchFetchWhitelistByCustomer,
  watchUpdateWhitelistByCustomer
} from './cm/alertDetails';
import {
  watchAddAutomation,
  watchDeleteAutomation,
  watchFetchAutomationCustomers,
  watchFetchAutomationList,
  watchSaveAutomationCustomers,
  watchSetPriority,
  watchUpdateAutomation,
  watchUpdateAutomationEnabledFlag,
  watchUpdateAutomationName
} from './cm/automation';
import { watchCreateCaseFromAlert } from './cm/convertAlertsToCase';
import { watchMergeAlertsToCase } from './cm/mergeAlertsToCase';
import {
  watchFetchAlertList,
  watchAssignAlertsToUser,
  watchAlertActionInfoModalClose,
  watchFetchTypologies,
  watchFetchSources,
  watchFetchAlertRetryHistoryList
} from './cm/alertList';
import { watchCreateCase, watchUpdateCase } from './cm/caseCreation';
import { watchFetchCustomerList } from './cm/customers';
import {
  watchFetchCaseList,
  watchAssignCaseToUser,
  watchAssignCaseActionInfoModalClose
} from './cm/caseList';
import { watchGetInvestigatorsWorkloadWorker } from './cm/investigators';
import { watchCaseActionSubmit } from './cm/caseAction';
import { watchfetchHistory } from './cm/caseHistory';
import { watchfetchAlertNoteHistory, watchAddAlertNote } from './cm/alertNote';
import {
  watchFetchDashboardBins,
  watchFetchTotalPendingAlerts,
  watchFetchCaseAgingStats
} from './cm/dashboard';
import {
  watchFetchWorkFlowStatusList,
  watchUpdateWorkFlowStatusList
} from './cm/workFlowStatus';

import { watchFetchMakerCheckerList } from './cm/makerChecker';
import {
  watchApproveCustomers,
  watchDeleteCustomers,
  watchFetchWhiteList,
  watchFetchWhiteListDetails,
  watchUpdateWhitelistName
} from './cm/whiteList';
import { watchLoadAppContext } from './cm/app';

import {
  watchAMLSCommonUnifiedAlerts,
  watchAMLSCommonAlertDetails,
  watchAMLSCommonAlertPartyIdentity,
  watchAMLSCommonAlertAssocCustomers,
  watchAMLSCommonGetTickets,
  watchAMLSCommonApproveAndRejectTicket,
  watchAMLSCommonAlertPartyUpdate,
  watchAMLSCommonGetSandboxUI,
  watchAMLSCommonKYCAlerts,
  watchGetDynamicPropertiesCategories,
  watchGetDynamicProperties,
  watchPutDynamicPropertiesUpdate,
  watchGetPipelines,
  watchPostPipelinesRun,
  watchPostPipelinesSchedule,
  watchPostPipelinesUnSchedule,
  watchGetPipelinesScheduleInfo,
  watchGetPipelinesHistory,
  watchAMLSCommonKYCAlertsDownload,
  watchPostPipelineStop,
  watchAMLSCommonTypologyActions,
  watchAMLSCommonUnifiedAlertsPrevention,
  watchGetCommonNotifications
} from './common';
import {
  watchAMLSTMCommonTransactionHistory,
  watchAMLSTMCommonTransactionHistoryDownload,
  watchAMLSTMCommonTransactionTriggeredTypologies,
  watchTMCommonScoreExplainablity,
  watchPreventionCommonScoreExplainablity,
  watchTMCommonPeerAndProfileGraph,
  watchTMTyplologyList,
  watchTMRiskIndicatorList,
  watchAMLSTMCommonTransactionTriggeredVariants,
  watchAMLSTMCommonCustomerLoanDetails,
  watchDownloadAMLSTMCommonCustomerLoanDetails
} from './tmCommon';

export default function* root() {
  yield all([
    fork(watchGetTmMetadata),

    fork(watchLogin),
    fork(watchUserModules),
    fork(watchLogout),
    fork(watchChangePassword),
    fork(watchChangeRole),
    fork(watchResetLogout),

    fork(watchGetStatusCount),
    fork(watchGetColumnData),
    fork(watchGetInvestigationData),
    fork(watchGetAlertDetail),
    fork(watchgetTransaction),
    fork(watchgetHistAlertHeader),
    fork(watchGetHistAlert),
    fork(watchGetLinkedCustomerAlert),
    fork(watchGetRiskIndicators),
    fork(watchGetRiskIndicatorsGraph),
    fork(watchGetCountries),
    fork(watchGetTransactionTypes),
    fork(watchGetFeatureCategoryTypes),
    fork(watchGetClusterViewDescription),
    fork(watchGetTransactionProductMapping),
    fork(watchCloseAlert),

    fork(nsWatchGetAnalystThroughputData),
    fork(nswatchGetSupervisorDashboardData),
    fork(nswatchGetMatchingConfigParametersData),

    fork(nsWatchGetInvestListData),
    fork(watchDownloadSelectedAlerts),
    fork(watchCustomerTypesSegmentAlerts),
    fork(watchSendToCMAlerts),
    fork(nsWatchsaveMatchingConfigToStore),
    fork(nsWatchGetInvestDetailData),
    fork(nsWatchGetInvestDetailHitsData),
    fork(nsWatchGetInvestDetailPastHitsData),

    // NS Dashboard
    fork(nsDashboardWatchFigureData),
    fork(nsDashboardWatchAlertsAndHits),
    fork(nsDashboardWatchHitsDistribution),
    fork(nsDashboardSegments),
    fork(nsDashboardSegmentsAndParameters),
    fork(nsCustomerView),

    // TM Settings
    fork(tmWatchTMGetAlertListingColumns),
    fork(watchTMPutAlertsListingSettings),
    fork(watchTMGetAlertsListingSettings),
    //phase 3
    fork(watchGetGlobalSettingsPageInfo),
    fork(watchPutGlobalSettingsWidgetGroup),
    fork(watchPutGlobalSettingsWidgets),
    fork(watchPutGlobalSettingsWidgetInfo),
    fork(watchTMAlertDetailsColumns),
    fork(watchGetCategoriesRunInstance),
    fork(watchGetLiveSetsRunInstance),
    fork(watchPostSegmentSetsRunInstance),
    //extension

    // TRM Configurations
    fork(watchTRMGetConfigurations),
    fork(watchTRMPutConfigurations),

    //Scenario Risk Indicator
    fork(watchGetRIByScenarioId),
    fork(watchPutRIByScenarioId),
    fork(watchGetRIListByScenarioId),

    // TM Dashboard
    fork(tmWatchGetFigureData),
    fork(tmWatchGetAlertsAndHits),
    fork(tmWatchGetAlertsYield),
    fork(tmWatchGetNoIssueL1),
    fork(tmWatchGetStr),
    fork(tmWatchAlertStatusBreakdown),
    fork(tmWatchSegmentList),
    //extension
    fork(watchTMGetPageItemOperations),
    fork(tmWatchCustomerView),
    fork(tmWatchCustomerClusterChart),

    // CRS Dashboard
    fork(crsDashboardWatchGetSegmentListData),
    fork(crsWatchGetModelListData),
    fork(crsWatchGetClusterChartData),
    fork(crsWatchGetClusterFeaturesData),
    fork(crsWatchGetClusterCustomerListData),
    fork(crsWatchCrsDashboardGetFeatureCodesData),
    fork(crsWatchCrsGetInitialDashboardData),
    fork(crsWatchCrsResetDashboardData),

    // CRS LIST VIEW
    fork(crsWatchGetCustomerListData),
    fork(crsWatchGetSegmentListData),
    fork(crsWatchGetClusterListData),
    fork(crsWatchGetCustomerTypeListData),
    fork(crsWatchGetRiskLevelChangeListData),

    // CRS RISK INDICATOR
    fork(crsWatchGetRiskIndicators),
    fork(crsWatchGetRiskIndicatorThresholds),
    fork(crsWatchPutRiskIndicatorThreshold),
    fork(crsWatchDeleteRiskIndicatorThreshold),
    fork(crsWatchUpdateRiskIndicatorThreshold),
    fork(crsWatchGetRiskIndicatorStaticProperties),
    fork(crsWatchPostRiskIndicatorTrigger),

    // CRS RISK DETAIL
    fork(crsWatchCRSClusterViewDescriptionCodesAPIView),
    fork(crsWatchCRSFeaturesCodesView),
    fork(crsWatchCRSFeatureCategoryCodesView),
    fork(crsWatchCRSTransactionProductMappingView),
    fork(crsWatchCRSTransactionTypesView),
    fork(crsWatchCustomerProfileView),
    fork(crsWatchAssociatedCustomersView),
    fork(crsWatchClusterInformationView),
    fork(crsWatchCRSTransactionHistoryView),
    fork(crsWatchCRSCustomerAlertHistoryView),
    fork(crsWatchCRSRiskIndicatorsView),
    fork(crsWatchCRSRiskIndicatorsGraphView),
    fork(crsWatchCRSModelExplainabilityView),
    fork(crsWatchCRSModelExplainabilityStatsView),
    fork(crsWatchTrendAnalysisDataView),
    fork(crsWatchUpdateRiskScoreHistoryView),
    fork(crsWatchGetRiskScoreHistoryView),
    fork(crsWatchAcceptRiskScoreView),

    // TRM DASHBOARD
    fork(watchFetchScenarioTypologies),
    fork(watchSaveTypologySegments),
    fork(watchGetTypologyListData),
    fork(watchUploadConfirmData),
    fork(watchUploadDiscardTypologiesData),
    fork(watchGetAllScenariosAPIData),
    fork(watchGetScenarioDetailAPIData),
    fork(watchGetScenarioDetailReset),
    fork(watchCreateScenariosAPIData),
    fork(watchDeleteScenariosAPIDataWorker),
    fork(watchUpdateScenariosAPIDataWorker),
    fork(watchAddTypologyToScenariosAPIDataWorker),
    fork(watchGetBlackListData),
    fork(watchTriggerScenariosAPIDataWorker),
    fork(watchRemoveTypologyFromScenarioDataWorker),
    fork(watchCloneScenarioDataWorker),
    fork(watchGetTypologyListOfScenariosData),
    fork(watchRunInstanceHistoryDataWorker),
    fork(watchPutTypologyOfScenariosListDataWorker),
    fork(watchFetchTicketsDataWorker),
    fork(watchApproveRejectTicketsDataWorker),
    fork(watchFetchCurrentChampionDataWorker),
    fork(watchFetchCurrentChampionResetDataWorker),
    fork(watchFetchCurrentChallengerWorker),
    fork(watchCreateChallengerDataWorker),
    fork(watchGetChallengersSummaryAPIData),
    fork(watchGetChallengersSummaryReset),
    fork(watchGetChallengersSummaryReset),
    fork(watchRevertCurrentChampionAPIData),
    fork(watchPromoteChallengerAPIData),

    // CM
    fork(watchFetchAlertList),
    fork(watchFecthAlertDetailsByAlertId),
    fork(watchFetchWhitelistByCustomer),
    fork(watchUpdateWhitelistByCustomer),
    fork(watchFetchCaseList),
    fork(watchFecthCaseDetailsByCaseId),
    fork(watchChangeAlertStatus),
    fork(watchChangeAlertAssignToUser),
    fork(watchCaseActionSubmit),
    fork(watchAssignAlertsToUser),
    fork(watchGetInvestigatorsWorkloadWorker),
    fork(watchAlertActionInfoModalClose),
    fork(watchFetchTypologies),
    fork(watchFetchSources),
    fork(watchfetchHistory),
    fork(watchAddAlertNote),
    fork(watchfetchAlertNoteHistory),
    fork(watchAssignCaseToUser),
    fork(watchCreateCaseFromAlert),
    fork(watchMergeAlertsToCase),
    fork(watchFetchTotalPendingAlerts),
    fork(watchFetchDashboardBins),
    fork(watchFetchCaseAgingStats),
    fork(watchFetchMakerCheckerList),
    fork(watchCreateCase),
    fork(watchUpdateCase),
    fork(watchFetchCustomerList),
    fork(watchLoadAppContext),
    fork(watchAssignCaseActionInfoModalClose),
    fork(watchFetchWorkFlowStatusList),
    fork(watchUpdateWorkFlowStatusList),
    fork(watchFetchAutomationCustomers),
    fork(watchFetchWhiteList),
    fork(watchFetchWhiteListDetails),
    fork(watchUpdateWhitelistName),
    fork(watchApproveCustomers),
    fork(watchDeleteCustomers),
    fork(watchFetchAutomationList),
    fork(watchAddAutomation),
    fork(watchSaveAutomationCustomers),
    fork(watchUpdateAutomation),
    fork(watchUpdateAutomationName),
    fork(watchUpdateAutomationEnabledFlag),
    fork(watchDeleteAutomation),
    fork(watchSetPriority),
    fork(watchFetchAlertRetryHistoryList),

    // NS: IAD
    fork(nsWatchGetMatchingConfigListData),
    fork(watchNSMatchingConfigListingSettings),
    fork(nsWatchPostCreateMatchingConfigData),
    fork(nsWatchGetMatchingConfigByIdData),
    fork(nsWatchPutUpdateMatchingConfigData),
    fork(nsWatchGetMatchingConfigData),
    fork(nsWatchGetRunInstanceResultListData),
    fork(nsWatchGetRunInstanceSummaryData),
    fork(nswatchGetRIWatchList),
    fork(nswatchGetRIWatchListCoverageReports),
    fork(nswatchGetRIWhiteList),
    fork(nsWatchGetAlertDetailData),
    fork(nsWatchPostHitsUserFeedback),
    fork(nsWatchPostDeployToProduction),
    fork(nswatchRunInstance),
    fork(nsWatchRunRunInstance),
    fork(nsWatchGetCutsomerType),
    fork(nsWatchPostCustomerType),
    fork(nsWatchPutCustomerType),
    fork(nsWatchDeleteCustomerType),
    fork(nsWatchPostCreateTicketForChampion),
    fork(nsWatchGetCurrentChampion),
    fork(nsWatchGetChampionChallengerDetails),
    fork(nsWatchRunInstanceViewExecution),
    fork(nsWatchGetMatchingConfigRiskIndicatorList),
    fork(nswatchGetMatchingConfigRiskParametersData),
    fork(nsWatchGetSegmentsList),
    fork(nsWatchProceedScreening),
    fork(nsWatchScanUploadedFile),
    fork(nsWatchODNSHistoryCsvFileDownload),
    fork(nsWatchProceedBulkScreening),
    fork(nsWatchGetScreeningProgress),
    fork(nsWatchGetMatchingConfigsBySegment),
    fork(nsWatchCancelHistoryDownload),
    fork(nsWatchStopBulkScreening),

    //AMLS Common
    fork(watchAMLSCommonKYCAlerts),
    fork(watchAMLSCommonTypologyActions),
    fork(watchAMLSCommonKYCAlertsDownload),
    fork(watchAMLSCommonUnifiedAlerts),
    fork(watchAMLSCommonUnifiedAlertsPrevention),
    fork(watchAMLSCommonGlobalSettings),
    fork(watchAMLSCommonAlertDetails),
    fork(watchAMLSCommonAlertPartyIdentity),
    fork(watchAMLSCommonAlertAssocCustomers),
    fork(watchAMLSCommonGetTickets),
    fork(watchAMLSCommonApproveAndRejectTicket),
    fork(watchAMLSCommonAlertPartyUpdate),
    fork(nswatchGetNSCommomModuleData),
    fork(watchAMLSCommonGetSandboxUI),
    fork(watchGetDynamicPropertiesCategories),
    fork(watchGetDynamicProperties),
    fork(watchPutDynamicPropertiesUpdate),
    fork(watchGetPipelines),
    fork(watchPostPipelinesRun),
    fork(watchPostPipelinesSchedule),
    fork(watchPostPipelinesUnSchedule),
    fork(watchGetPipelinesScheduleInfo),
    fork(watchGetPipelinesHistory),
    fork(watchPostPipelineStop),
    fork(watchGetCommonNotifications),
    // AMLS TM COMMON
    fork(watchAMLSTMCommonTransactionHistory),
    fork(watchAMLSTMCommonTransactionHistoryDownload),
    fork(watchAMLSTMCommonTransactionTriggeredTypologies),
    fork(watchAMLSTMCommonTransactionTriggeredVariants),
    fork(watchTMCommonScoreExplainablity),
    fork(watchPreventionCommonScoreExplainablity),
    fork(watchTMCommonPeerAndProfileGraph),
    fork(watchTMTyplologyList),
    fork(watchTMRiskIndicatorList),
    fork(watchAMLSTMCommonCustomerLoanDetails),
    fork(watchDownloadAMLSTMCommonCustomerLoanDetails)
  ]);
}
